module.exports = __webpack_public_path__ + "img/MF-A136A-BS-HQ.0b9f9729.png";